.ground-button{display:flex;width:32px;height:30px;padding:0}.ground-icon{display:flex;justify-content:center;align-items:center;color:#000;background-color:#fff;font-size:32px;width:100%;height:100%;border-radius:10%}
/*# sourceMappingURL=auto-ground-button.component.css.map */
